import { MappingPair, Profile } from "@dynamic-mapper/mapper";
import { LocationDTO } from "src/app/domain/location/location.dto";
import { Location } from "../../models/common/location.model";

export class LocationProfile extends Profile {
    static readonly DtoToDomain = new MappingPair<Location, LocationDTO>();

    constructor() {
        super();

        this.createMap(LocationProfile.DtoToDomain, {
            id: opt => opt.mapFrom(src => src.id),
            locationName: opt => opt.mapFrom(src => src.locationName),
            clientName: opt => opt.mapFrom(src => src.clientName),
            city: opt => opt.mapFrom(src => src.city),
            state: opt => opt.mapFrom(src => src.state),
            image: opt => opt.mapFrom(src => src.image),
        })
    }
}
